import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgWaving: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 295 339" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M48.13 94.66S-20.89 151.6 7.07 173.4c0 0 11.56 5.88 14.72-7.5 0 0 14.01 3.91 14.24-9.58 0 0 13.83 7.1 20.58-8.5 0 0 6.89-14.71 2.76-38.61 0 0-4.6-15.33-11.24-14.56z"
        fill="#E06D17"
      />
      <g transform="translate(-2)" fillRule="nonzero">
        <path
          d="M214.66 330.1c0-6.88-31.91-13.25-71.28-13.25-39.36 0-71.27 5.27-71.27 12.14 0 6.88 31.9 9.65 71.27 9.65s71.28-1.67 71.28-8.55z"
          fill="#000"
          opacity={0.28}
        />
        <path
          d="M249.08 63.67c-.82-17.87-4.48-30.94-4.48-30.94-4.82-27.86-11.79-19.85-31.17-7.98a128.52 128.52 0 0 0-75.4-24.3c-28.37 0-54.6 9.17-75.91 24.69C44.6 12.42 41.8 8 31.32 26.98c0 0-5.88 16.4-8.51 44.3a128.57 128.57 0 0 0-13.88 58.29c0 71.3 53.93 123.95 129.24 122.42 80.2-1.63 128.98-51.11 128.98-122.42 0-24.08-6.6-46.6-18.07-65.9z"
          fill="#FF7C1F"
        />
        <path
          d="M249.08 63.67c-.82-17.87-4.48-30.94-4.48-30.94-4.82-27.86-11.79-19.85-31.17-7.98a128.52 128.52 0 0 0-75.4-24.3c-28.37 0-54.6 9.17-75.91 24.69C44.6 12.42 41.8 8 31.32 26.98c0 0-5.88 16.4-8.51 44.3a128.57 128.57 0 0 0-13.88 58.29c0 71.3 53.93 123.95 129.24 122.42 80.2-1.63 128.98-51.11 128.98-122.42 0-24.08-6.6-46.6-18.07-65.9z"
          fill="#FF7C1F"
        />
        <path
          d="M97.49 247.16c17.5 3.42 31.06 5.03 40.67 4.83 80.2-1.63 129-51.11 129-122.42-.01-12.81-3.92-30.76-11.74-53.84 13.64 55.62 1.8 101.04-35.56 136.26-34.24 32.29-75.03 44.01-122.37 35.17z"
          fill="#E06D17"
        />
        <g transform="translate(118 68)">
          <circle cx={40.47} cy={41.08} r={40.29} opacity={0.1} fill="#000" />
          <circle fill="#FFF" cx={40.47} cy={46.41} r={40.29} />
        </g>
        <g transform="translate(20 68)">
          <ellipse
            cx={36.26}
            cy={41.22}
            rx={35.62}
            ry={40.62}
            opacity={0.1}
            fill="#000"
          />
          <ellipse fill="#FFF" cx={36.26} cy={46.59} rx={35.62} ry={40.62} />
        </g>
        <circle fill="#404040" cx={164.48} cy={127.37} r={11.46} />
        <circle fill="#404040" cx={72.89} cy={127.69} r={11.46} />
        <path
          d="M223.49 154.72s23.24-95.35 54.73-78.3c0 0 10.17 8.56-.72 18.1 0 0 9.34 9.68-2.81 18.63 0 0 12.23 10.2.8 24.36 0 0-10.55 13.85-34.05 21.28 0 0-15.9 2.83-17.95-4.07z"
          fill="#E06D17"
        />
        <path
          d="M223.49 154.72s23.24-95.35 54.73-78.3c0 0 10.17 8.56-.72 18.1 0 0 9.34 9.68-2.81 18.63 0 0 12.23 10.2.8 24.36 0 0-10.55 13.85-34.05 21.28 0 0-15.9 2.83-17.95-4.07z"
          fill="#E06D17"
        />
      </g>
      <path
        d="M79.34 165.52s20.43 15.2 24.5 22.19c0 0 5.56-6.83 15.42-14.2l9.75-7.48s-47.76.57-49.67-.51z"
        fill="#FFF"
        fillRule="nonzero"
      />
      <path
        fill="#404040"
        fillRule="nonzero"
        d="M122.4 167.2l-18.36 14.63-21.16-14.95z"
      />
      <path
        d="M75.88 165.76s14.46-9.57 28.28-22.18c0 0 15.48 10.75 25.93 21.35 0 0 2.08.65-15.26 3.65 0 0-28.55 2.6-38.95-2.82z"
        fill="#FFF"
        fillRule="nonzero"
      />
      <path
        d="M272.62 53.73s21.55-10.16 22.07 18.76c0 0-3.12-20.57-22.07-18.76zm-5.59 8.23s21.55-10.16 22.07 18.76c0 0-3.12-20.57-22.07-18.76z"
        fill="#8C8C8C"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgWaving;
